import { useAuthStore } from '@/store/auth'

export const setupRouterGuard = (router) => {
  router.beforeEach((to, from, next) => {
    const authStore = useAuthStore()
    const isAuthenticated = authStore.isAuthenticated
    
    // 检查目标路由是否需要认证
    if (to.meta.requiresAuth && !isAuthenticated) {
      // 重定向到登录页，并保存原始目标路径
      next({ 
        name: 'Login', 
        query: { redirect: to.fullPath } 
      })
    } else {
      // 继续路由跳转
      next()
    }
  })
}